export default __webpack_public_path__ + "static/media/japango-screenshot-03.f198f68b.png";